module.exports = __webpack_public_path__ + "catalog/items/bathroom/round_sink/round-sink.svg";